import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../services/user.service';
import { CustomValidators } from 'ng2-validation';
import { CommonService } from '../../../services/common.service';
import { environment } from 'src/environments/environment';
import { maxYearFunction } from '../../../_helpers/utility';
import { MustMatch } from '../../../_helpers/must-match.validator';
import * as moment from 'moment-timezone';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { FileUpload } from 'primeng/fileupload';

@Component({
    selector: 'app-admin-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    providers: [MessageService]
})

export class AdminEditComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    id;
    userForm: FormGroup;
    submitted = false;
    uploadedFiles: any[] = [];
    file: File;
    reader: FileReader;
    public profilepic;
    errorMessage = '';
    public item: any[] = [];
    countrylist: any = [];
    statelist: any = [];
    citylist: any = [];
    genders: any = [];
    public imageProfile;
    showProfile = false;
    statuses: any = [];
    userstatus: any;
    usergender: any;
    selectedStatus: any;
    countryname;
    countrycode;
    statename;
    statecode;
    cityname;
    citycode;
    dob: Date;
    bDate;
    dobdt: Date;
    yearRange;
    public defaultDate: Date = new Date(environment.defaultDate);
    minYear = environment.minYear;
    timeZoneArray = [];
    timeZoneOffset;
    timeZone;
    cpassword: boolean;
    newPasswordCheck: boolean;
    newPasswordDisable: boolean;
    @ViewChild('fileUpload') fileUpload!: FileUpload;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropDialog: boolean = false;
    selectedFile: File | null = null;
    imageSize = 1000000;
    croppedImageMaxSize = 1000000;
    croppedImageSize = 0;
    croppedImageError: string | null = null;
    scale = 1;
    transform: ImageTransform = {};
    cropApplied = false;
    isApplyingCrop = false;
    isSubmitting = false;
    private acceptedProfileFile: File | null = null;
    private previousAcceptedProfileFile: File | null = null;
    private previousUploadedFiles: any[] = [];
    private previousProfilepic: any = undefined;
    private previousImageProfile: any = null;
    private previousShowProfile = false;
    private serverProfileImage: any = null;
     isTeamUser: boolean = false;
    constructor(private userService: UserService, private commonService: CommonService, private formBuilder: FormBuilder, private messageService: MessageService,
        private router: Router, private activeroute: ActivatedRoute) { }

    ngOnInit(): void {
        const timeZones = moment.tz.names();
        for (const timezone of timeZones) {
            this.timeZoneArray.push({ name: timezone, code: moment().tz(timezone).format('Z') });
        }
        this.defaultDate.setDate(this.defaultDate.getDate() - 5);
        this.yearRange = this.minYear + ":" + maxYearFunction();
        this.id = this.activeroute.snapshot.params.id;
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false }
        ];
        this.genders = [
            { name: 'Male', code: 'Male' },
            { name: 'Female', code: 'Female' },
            { name: 'Other', code: 'Other' },
        ];
        this.getUserDetails(this.id);
        this.getCountry();
        this.timeZone = moment.tz.guess();
        this.timeZoneOffset = moment().tz(this.timeZone).format('Z');
        this.userForm = this.formBuilder.group({
            firstName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
            lastName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
            email: ['', [Validators.required, Validators.email, CustomValidators.email]],
            // password: ['', [Validators.required, Validators.minLength(6)]],
            // confirmPassword: ['', Validators.required],
            mobileNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
            address: [''],
            country: ['', Validators.required],
            state: [''],
            city: [''],
            zipcode: [''],
            status: [''],
            gender: ['', Validators.required],
            dob: ['', Validators.required],
            timeZone: [{ name: this.timeZone, code: this.timeZoneOffset }, Validators.required],
            currentPassword: [''],
            password: [''],
            confirmPassword: [''],
        }, {
            validator: MustMatch('password', 'confirmPassword')
        });
        this.cpassword = false;
        this.newPasswordCheck = false;
        this.newPasswordDisable = true;
    }
    newPassword(event) {
        if (this.userForm.controls['password'].value != '' && this.userForm.controls['currentPassword'].value == '') {
            this.userForm.controls['currentPassword'].setValidators([Validators.required]);
            this.userForm.controls['currentPassword'].updateValueAndValidity();
            this.cpassword = true;
            this.newPasswordCheck = false;
        }
        else if(this.userForm.controls['password'].value !== '') {
            this.newPasswordCheck = false;
        } 
        else {
            this.cpassword = false;
        }
    }
    newPasswordValidation(event) {
        this.userForm.get('password').enable()
        this.userForm.get('confirmPassword').enable()
        if (this.userForm.controls['currentPassword'].value != '' && this.userForm.controls['password'].value == '') {
            this.userForm.controls['password'].setValidators([Validators.pattern("^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{6,}$")]);
            this.newPasswordCheck = true;
            this.cpassword = false;
        } 
        else if (this.userForm.controls['password'].value !== '' && this.userForm.controls['currentPassword'].value === '') {
            this.userForm.controls['currentPassword'].setValidators([Validators.required]);
            this.userForm.controls['currentPassword'].updateValueAndValidity();
            this.cpassword = true;
        }
        else {
            this.newPasswordCheck = false;
            this.cpassword = false;
        }
    }
    getUserDetails(id) {
        this.userService.getUserDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.item = data;
                this.isTeamUser = this.item ['rolename'] === 'Team';
                if (this.item) {
                    this.getStates("false", this.item['countrycode']);
                    // this.userForm.get('country').setValue({ name: this.item['countryname'], code: this.item['countrycode'] });
                    const selectedCountry = this.countrylist.find(c => c.code === this.item['countrycode']);
                    if (selectedCountry) {
                        this.userForm.get('country').setValue(selectedCountry);
                    }
                    if (this.item['statecode']) {
                        this.getCities("false", this.item['statecode']);
                        this.userForm.get('state').setValue({ name: this.item['statename'], code: this.item['statecode'] });
                    }
                    if (this.item['citycode']) {
                        this.userForm.get('city').setValue({ name: this.item['cityname'], code: this.item['citycode'] });
                    }
                    var bDate = moment(this.item['dob'], 'DD-MM-YYYY');
                    this.bDate = bDate.format('DD-MM-YYYY');
                    this.userForm.patchValue({
                        firstName: this.item['firstName'],
                        lastName: this.item['lastName'],
                        email: this.item['email'],
                        mobileNumber: this.item['mobileNumber'],
                        // country: this.item['country'],
                        // state: this.item['state'],
                        // city: this.item['city'],
                        zipcode: this.item['zipcode'],
                        address: this.item['address'],
                        dob: this.bDate,
                    });

                    this.countrycode = this.item['countrycode'];
                    this.countryname = this.item['countryname'];
                    this.statecode = this.item['statecode'];
                    this.statename = this.item['statename'];
                    this.citycode = this.item['citycode'];
                    this.cityname = this.item['cityname'];
                    var statusobj;
                    if (this.item['status'] == true) {
                        statusobj = { label: 'Active', value: true };
                    } else {
                        statusobj = { label: 'In-Active', value: false };
                    }
                    // this.userForm.get('status').setValue(statusobj);
                    this.userForm.get('status').setValue(this.item['status']); 
                    this.userForm.get('gender').setValue({ name: this.item['gender'], code: this.item['gender'] });
                    this.userForm.get('timeZone').setValue({ name: this.item['timeZone'], code: this.item['timeZoneOffset'] });
                    if (this.item['profilepic'] != undefined && this.item['profilepic'] !== null && this.item['profilepic'] !== '') {
                        this.serverProfileImage = this.item['profilepic'];
                        if (!this.acceptedProfileFile) {
                            this.imageProfile = this.serverProfileImage;
                            this.showProfile = true;
                        }
                    } else {
                        this.serverProfileImage = null;
                        if (!this.acceptedProfileFile) {
                            this.imageProfile = null;
                            this.showProfile = false;
                        }
                    }
                }
                this.userForm.get('email').disable();
                this.userForm.get('password').disable()
                this.userForm.get('confirmPassword').disable()
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    get f() {
        return this.userForm.controls;
    }

    onFileSelect(event: any) {
        const file = event.files[0];
        if (!file) return;

        this.capturePreviousImage();
        this.cropApplied = false;
        if (file.size > this.imageSize) {
            this.rejectOversizedImage();
            return;
        }

        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = file;
        this.isApplyingCrop = false;
        this.resetZoom();
        this.imageChangedEvent = {
            target: {
                files: [file]
            }
        };
        this.cropDialog = true;
    }

    get cropDialogTitle(): string {
        return 'Crop & Adjust Profile Photo';
    }

    get cropDialogSubtitle(): string {
        return 'Position and scale the image for a 512 x 512 crop';
    }

    get cropPreviewLabel(): string {
        return '512 x 512 px - High Quality JPEG';
    }

  zoomIn() {
      this.scale += 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }

    zoomOut() {
      if (this.scale > 0.2) {
        this.scale -= 0.1;
        this.transform = {
          ...this.transform,
          scale: this.scale
        };
      }
    }

    resetZoom() {
      this.scale = 1;
      this.transform = {
        ...this.transform,
        scale: 1
      };
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
        this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
            ? 'Cropped image size must not exceed 1 MB.'
            : null;
    }

    onCropImageLoadFailed() {
        this.croppedImage = null;
        this.croppedImageSize = 0;
        this.croppedImageError = 'This image could not be loaded. Please choose a valid image file.';
    }

    getBase64SizeBytes(base64: string): number {
        if (!base64) return 0;
        return Math.round(
            (base64.length * (3 / 4)) -
            (base64.split(',')[0].length + 1)
        );
    }

    applyCrop() {
        if (this.isApplyingCrop || this.croppedImageError || !this.croppedImage || !this.selectedFile) return;
        this.isApplyingCrop = true;
        const file = this.base64ToFile(
            this.croppedImage,
            this.getOutputFileName(this.selectedFile.name)
        );
        if (file.size > this.croppedImageMaxSize) {
            this.croppedImageError = 'Cropped image size must not exceed 1 MB.';
            this.isApplyingCrop = false;
            return;
        }

        (file as any).objectURL = this.croppedImage;
        this.profilepic = this.croppedImage;
        this.uploadedFiles = [file];
        this.acceptedProfileFile = file;
        this.showProfile = false;
        if (this.fileUpload) {
            this.fileUpload.clear();
            this.fileUpload.files = [file];
        }
        this.cropApplied = true;
        this.cropDialog = false;
    }

    onCropCancel() {
        this.cropApplied = false;
        this.cropDialog = false;
    }

    onDialogHide() {
        if (!this.cropApplied) {
            this.restorePreviousImage();
        }
        this.resetCropState();
    }

    onProfilePhotoRemove() {
        this.uploadedFiles = [];
        this.profilepic = undefined;
        this.acceptedProfileFile = null;
        this.imageProfile = this.serverProfileImage;
        this.showProfile = !!this.serverProfileImage;
    }

    private capturePreviousImage() {
        this.previousUploadedFiles = [...this.uploadedFiles];
        this.previousProfilepic = this.profilepic;
        this.previousAcceptedProfileFile = this.acceptedProfileFile;
        this.previousImageProfile = this.imageProfile;
        this.previousShowProfile = this.showProfile;
    }

    private restorePreviousImage() {
        this.uploadedFiles = [...this.previousUploadedFiles];
        this.profilepic = this.previousProfilepic;
        this.acceptedProfileFile = this.previousAcceptedProfileFile;
        if (!this.previousAcceptedProfileFile && this.serverProfileImage) {
            this.imageProfile = this.serverProfileImage;
            this.showProfile = true;
        } else {
            this.imageProfile = this.previousImageProfile;
            this.showProfile = this.previousShowProfile;
        }
        if (this.fileUpload) {
            this.fileUpload.clear();
            this.fileUpload.files = this.acceptedProfileFile ? [this.acceptedProfileFile] : [];
        }
    }

    private resetCropState() {
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = null;
        this.previousUploadedFiles = [];
        this.previousProfilepic = this.profilepic;
        this.previousAcceptedProfileFile = this.acceptedProfileFile;
        this.previousImageProfile = this.imageProfile;
        this.previousShowProfile = this.showProfile;
        this.cropApplied = false;
        this.isApplyingCrop = false;
        this.resetZoom();
    }

    rejectOversizedImage() {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image no larger than 1 MB', life: 6000 });
        this.restorePreviousImage();
        this.resetCropState();
    }

    base64ToFile(data: string, filename: string): File {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    private getOutputFileName(filename: string | undefined): string {
        const baseName = (filename || 'profile-photo').replace(/\.[^/.]+$/, '');
        return `${baseName}.jpg`;
    }

    picUploader(event) {
        const files: File[] = event?.files || event;
        if (!files || files.length === 0) return;
        const file = files[0];
        this.uploadedFiles = [file];
        this.acceptedProfileFile = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.profilepic = reader.result;
            this.showProfile = false;
        };
    }

    getCountry() {
        this.commonService.getCountryList().pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.countrylist = data.data.items;
                if (this.item && this.item['countrycode']) {
                    const selectedCountry = this.countrylist.find(c => c.code === this.item['countrycode']);
                    if (selectedCountry) {
                        this.userForm.get('country').setValue(selectedCountry);
                    }
                }
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    getStates(fromForm, event) {
        this.citylist = [];
        this.statecode = "";
        this.statename = "";
        this.citycode = "";
        this.cityname = "";

        if (fromForm == "true") {
            this.userForm.get('zipcode').reset();
            this.countrycode = event.value.code;
            this.countryname = event.value.name;
        } else {
            this.countrycode = event;
        }

        this.commonService.getStateList(this.countrycode).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.statelist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    getCities(fromForm, event) {
        this.citycode = "";
        this.cityname = "";
        if (fromForm == "true") {
            this.userForm.get('zipcode').reset();
            this.statecode = event.value.code;
            this.statename = event.value.name;
        } else {
            this.statecode = event;
        }


        this.commonService.getCityList(this.statecode).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.citylist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    onCitySelect(event) {
        this.cityname = event.value.name;
        this.citycode = event.value.code;
        this.userForm.get('zipcode').reset();
    }

    onStatusSelect(event) {
        if (event) {
            this.userstatus = event.value;
        }
    }

    onGenderSelect(event) {
        if (event) {
            this.usergender = event.name;
        }
    }

    onTimezoneSelect(event) {
        this.timeZone = event.name;
        this.timeZoneOffset = event.code;
    }

    setDOB($event) {
        this.dobdt = $event; //moment($event).format("MM/DD/YYYY");
    }

    onSubmit() {
        if (this.isSubmitting) {
            return;
        }
        this.submitted = true;
        if (this.userForm.invalid) {
            return;
        }
        var userData = this.userForm.value;
        userData['profilepic'] = this.profilepic;
        // userData['status'] = this.userstatus;
        userData['status'] = this.userForm.get('status').value; 
        userData['countrycode'] = this.countrycode;
        userData['countryname'] = this.countryname;
        userData['statecode'] = this.statecode;
        userData['statename'] = this.statename;
        userData['citycode'] = this.citycode;
        userData['cityname'] = this.cityname;
        userData['gender'] = this.usergender;
        userData['timeZone'] = this.timeZone;
        userData['timeZoneOffset'] = this.timeZoneOffset;
        if (this.userForm.value.dob instanceof Date) {
            userData['dob'] = moment(this.userForm.value.dob, "DD-MM-YYYY").format("DD/MM/YYYY");
        } else {
            var dt = moment(this.userForm.value.dob, "DD-MM-YYYY").format("DD/MM/YYYY");
            userData['dob'] = dt;
        }
        userData = JSON.stringify(userData, null, 4);
        this.isSubmitting = true;
        this.userService.updateUser(this.id, userData).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Admin Data Updated Successfully!!', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/manage/admin']);
                }, 2000);
            },
            err => {
                this.isSubmitting = false;
                //this.errorMessage = err.error.message;
            }
        );
    }

    onReset() {
        this.submitted = false;
        this.userForm.reset();
    }

    backLink() {

        if (this.isTeamUser) {
            this.router.navigate(['/manage/teamdetails/']);
        } else {
            this.router.navigate(['/manage/admin']);
        }

    }

    ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
